<template>
  <div class="ss__custom__header__desktop__menu__wrapper">
    <div
      :class="[
        'ss__custom__header__desktop__menu',
        menuItemHovered ? 'ss__custom__header__desktop__menu--active' : ''
      ]">
      <div
        v-for="item in menu"
        :key="item.name"
        @mouseenter="onMouseenter(item, $event)"
        @mouseleave="onMouseleave">
        <SsDesktopMenuItem
          :class="[
            'ss__custom__header__desktop__menu__item',
            item.name === menuItemHovered ? 'ss__custom__header__desktop__menu__item--hover' : ''
          ]"
          :item="item"
          @click.native="onMenuItemClick(item, $event)"
        />
        <SafeArea
          v-if="hovered && menuItemHovered === item.name"
          :mouseX="mouseX"
          :mouseY="mouseY"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SafeArea from '../../../SafeArea/index.vue'
import SsDesktopMenuItem from '../SsDesktopMenuItem/index.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'SsDesktopMenu',

  components: {
    SsDesktopMenuItem,
    SafeArea
  },

  props: {
    menu: {
      type: Array,
      default: () => ([])
    },
    menuItemHovered: String
  },

  data () {
    return {
      isDesktop: false,
      hovered: false,
      timer: null,
      mouseX: 0,
      mouseY: 0
    }
  },

  methods: {
    show (name) {
      this.hovered = true
      this.$emit('show', name)
      dispatchEvent(new CustomEvent('ssCustomHeaderToggleTarget', { detail: 'menu' }))
    },
    hide () {
      this.$emit('hide')
      this.hovered = false
    },
    onMouseenter (item, event) {
      if (!this.isDesktop) return
      event.stopPropagation()
      if (this.menuItemHovered) {
        this.timer && clearTimeout(this.timer)
        this.timer = null
        this.show(item.name)
      } else {
        this.timer = setTimeout(() => {
          this.show(item.name)
        }, 300)
      }
      this.updateMousePosition(event)
    },
    onMouseleave (e) {
      this.hide()
      clearTimeout(this.timer)
      this.timer = null
    },
    updateMousePosition: debounce(function (e) {
      this.mouseX = e.clientX
      this.mouseY = e.clientY - 4
    }, 30),
    onMenuItemClick (item, event) {
      if (this.isDesktop) return
      if (this.menuItemHovered !== item.name) {
        event.preventDefault()
        this.show(item.name)
      }
    }
  },

  mounted () {
    this.isDesktop = !('ontouchstart' in window)
    window.addEventListener('mousemove', this.updateMousePosition)
  },

  destoryed () {
    window.removeEventListener('mousemove', this.updateMousePosition)
  }
}
</script>

<style lang="stylus" scoped>
.ss__custom__header__desktop__menu {
  display: flex;
  align-items: center;
  --color-SsDesktopMenuItemName: var(--color-SsCustomHeaderMenuName, var(--B8-t));
  --color-SsDesktopMenuItemIcon: var(--color-SsCustomHeaderMenuIcon, var(--B8-t));
  .ss__custom__header__desktop__menu__item {
    padding: 16px;
  }
  &.ss__custom__header__desktop__menu--active {
    --color-SsDesktopMenuItemName: var(--color-SsCustomHeaderMenuName--active, var(--B5-t));
    --color-SsDesktopMenuItemIcon: var(--color-SsCustomHeaderMenuIcon--active, var(--B5-t));
  }
  .ss__custom__header__desktop__menu__item--hover {
    --color-SsDesktopMenuItemName: var(--color-SsCustomHeaderMenuName--hover, var(--B8-t));
    --color-SsDesktopMenuItemIcon: var(--color-SsCustomHeaderMenuIcon--hover, var(--B8-t));
  }
}
</style>
